import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "onetrip-page pageAcceptTiket" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "infoLoad" }, "Выбор был сделан", -1)
const _hoisted_4 = {
  key: 1,
  class: "container"
}
const _hoisted_5 = { class: "pageAcceptTiket__filter" }
const _hoisted_6 = { class: "pageAcceptTiket__tiketsVariant" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "pageAcceptTiket__infoVar"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SubHeader = _resolveComponent("SubHeader")
  const _component_left_filter_accept_trip = _resolveComponent("left-filter-accept-trip")
  const _component_avia_tiket = _resolveComponent("avia-tiket")
  const _component_hotels_card_complex = _resolveComponent("hotels-card-complex")
  const _component_transfer_card = _resolveComponent("transfer-card")
  const _component_rail_tiket_small = _resolveComponent("rail-tiket-small")
  const _component_free_card = _resolveComponent("free-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SubHeader, {
      title: 'Выберите вариант',
      isMain: false,
      subText: "",
      canClose: false,
      canCreate: false
    }),
    (_ctx.userIsSelect)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (!_ctx.userIsSelect)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", null, [
              _createVNode("button", {
                class: "pageAcceptTiket__btnSend mb-8",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.sendData(...args)))
              }, " Отправить "),
              _createVNode(_component_left_filter_accept_trip)
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupByOffer, (itemGr) => {
                return (_openBlock(), _createBlock(_Fragment, {
                  key: itemGr.orderId
                }, [
                  (_ctx.checkType(itemGr.data))
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("h2", null, [
                          _createTextVNode(_toDisplayString(itemGr.noChoice ? "Предложение" : "Заказ") + " " + _toDisplayString(itemGr.orderId) + " ", 1 /* TEXT */),
                          (!itemGr.noChoice)
                            ? (_openBlock(), _createBlock("span", _hoisted_8, "Выбор уже сделан"))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemGr.data, (item, index) => {
                          return (_openBlock(), _createBlock(_Fragment, null, [
                            (
                    _ctx.isAvia(item.tiket) &&
                      _ctx.isSelect(item.tiket, item.offerData, itemGr.orderId) &&
                      _ctx.isSelectedOfferType(_ctx.orderTypes.AVIA) &&
                      (_ctx.isNotDenie(item.offerData) || itemGr.noChoice)
                  )
                              ? (_openBlock(), _createBlock(_component_avia_tiket, {
                                  key: item.tiket.key,
                                  item: item.tiket,
                                  small: false,
                                  btnTarrif: false,
                                  tripId: -1,
                                  isModeOffer: true,
                                  hasControl: itemGr.noChoice,
                                  hasCansel: _ctx.isSelectForce(item.offerData, itemGr.orderId),
                                  onSelectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  ),
                                  onUnselectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  )
                                }, null, 8, ["item", "hasControl", "hasCansel", "onSelectOffer", "onUnselectOffer"]))
                              : _createCommentVNode("", true),
                            (
                    _ctx.isHotel(item.tiket) &&
                      _ctx.isSelect(item.tiket, item.offerData, itemGr.orderId) &&
                      _ctx.isSelectedOfferType(_ctx.orderTypes.HOTEL) &&
                      (_ctx.isNotDenie(item.offerData) || itemGr.noChoice)
                  )
                              ? (_openBlock(), _createBlock(_component_hotels_card_complex, {
                                  hasControl: itemGr.noChoice,
                                  key: item.tiket.hotelName.bs.en,
                                  item: item.tiket,
                                  isModeOffer: true,
                                  hasCansel: _ctx.isSelectForce(item.offerData, itemGr.orderId),
                                  onSelectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  ),
                                  onUnselectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  )
                                }, null, 8, ["hasControl", "item", "hasCansel", "onSelectOffer", "onUnselectOffer"]))
                              : _createCommentVNode("", true),
                            (
                    _ctx.isService(item.tiket) &&
                      _ctx.isSelect(item.tiket, item.offerData, itemGr.orderId) &&
                      _ctx.isSelectedOfferType(_ctx.orderTypes.TRANSFER) &&
                      (_ctx.isNotDenie(item.offerData) || itemGr.noChoice)
                  )
                              ? (_openBlock(), _createBlock(_component_transfer_card, {
                                  key: item.tiket.SupplierContractId,
                                  item: item.tiket,
                                  isModeOffer: true,
                                  hasCansel: _ctx.isSelectForce(item.offerData, itemGr.orderId),
                                  onSelectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  ),
                                  onUnselectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  )
                                }, null, 8, ["item", "hasCansel", "onSelectOffer", "onUnselectOffer"]))
                              : _createCommentVNode("", true),
                            (
                    _ctx.isRail(item.tiket) &&
                      _ctx.isSelect(item.tiket, item.offerData, itemGr.orderId) &&
                      _ctx.isSelectedOfferType(_ctx.orderTypes.RAILWAY) &&
                      (_ctx.isNotDenie(item.offerData) || itemGr.noChoice)
                  )
                              ? (_openBlock(), _createBlock(_component_rail_tiket_small, {
                                  key: item.tiket.numberTrain,
                                  item: item.tiket,
                                  isModeOffer: true,
                                  hasCansel: _ctx.isSelectForce(item.offerData, itemGr.orderId),
                                  onSelectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  ),
                                  onUnselectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  )
                                }, null, 8, ["item", "hasCansel", "onSelectOffer", "onUnselectOffer"]))
                              : _createCommentVNode("", true),
                            (
                    _ctx.isFree(item.tiket) &&
                      _ctx.isSelect(item.tiket, item.offerData, itemGr.orderId) &&
                      _ctx.isSelectedOfferType(_ctx.orderTypes.FREE) &&
                      (_ctx.isNotDenie(item.offerData) || itemGr.noChoice)
                  )
                              ? (_openBlock(), _createBlock(_component_free_card, {
                                  key: item.tiket.SupplierContractId,
                                  item: item.tiket,
                                  isModeOffer: true,
                                  hasCansel: _ctx.isSelectForce(item.offerData, itemGr.orderId),
                                  onSelectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  ),
                                  onUnselectOffer: $event => (
                    _ctx.selectOffer($event, item.offerData, itemGr.orderId)
                  )
                                }, null, 8, ["item", "hasCansel", "onSelectOffer", "onUnselectOffer"]))
                              : _createCommentVNode("", true),
                            (_ctx.isApplied(item.offerData))
                              ? (_openBlock(), _createBlock("div", {
                                  key: index,
                                  class: "pageAcceptTiket__infoVar"
                                }, " Выбранный вариант "))
                              : _createCommentVNode("", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}